import React, { Component, PropTypes } from 'react';
import { createEvent } from 'googleanalytics';
import Modal from 'components/Modal';
import { Button } from 'muicss/react';
import { CATEGORIES, ACTIONS } from 'constants/googleAnalytics';
import GbpModalHeader from './Header';
import { GBP_VERIFICATION_STATUS } from 'constants/gbp';

const googleConfigs = APP_CONFIG.google;
const GMB_SESSION_SCHEDULE_LINK = 'https://www.solutions.sysco.com/request-a-project';

class GbpOverviewModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    changeVisibility: PropTypes.func,
    user: PropTypes.object,
    closeModal: PropTypes.func,
    verificationStatus: PropTypes.oneOf([...Object.keys(GBP_VERIFICATION_STATUS), null]),
    gbpSuccessAlert: PropTypes.bool,
    successAlertMessage: PropTypes.string,
    isCanadianUser: PropTypes.bool,
    modalContent: PropTypes.object,
  };

  closeGmbModal = () => this.props.closeModal();

  onGmbConsultationSceduleClick = (user) => {
    const { opcoId, syscoCustomerId } = user;
    createEvent(CATEGORIES.GBP, ACTIONS.SCHEDULE_CONSULTATION, `${ opcoId }-${ syscoCustomerId }`, user);
    window.open(GMB_SESSION_SCHEDULE_LINK, '_blank');
    this.closeGmbModal();
  }

  /**
   * get google login url
   * @returns google login url
   */
  static getGoogleLoginUrl = (isVettedTokenUser=false) => {
    const { clientId, authUrl, scope, redirectUri, vettedTokenRedirectUri } = googleConfigs;
    const googleAuthUrl = new URL(authUrl);
    googleAuthUrl.searchParams.append('client_id', clientId);
    googleAuthUrl.searchParams.append('scope', scope);
    googleAuthUrl.searchParams.append('response_type', 'code');
    googleAuthUrl.searchParams.append('redirect_uri', isVettedTokenUser ? vettedTokenRedirectUri : redirectUri);
    googleAuthUrl.searchParams.append('access_type', 'offline');
    googleAuthUrl.searchParams.append('prompt', 'consent');
    return googleAuthUrl.toString();
  }

  renderBody = ((user) => {
    const {
      onVisitGbpProfile,
      verificationStatus,
      gbpSuccessAlert,
      successAlertMessage,
      isCanadianUser,
      modalContent,
    } = this.props;

    return (
      <div className={ 'common-overlay-content centered-view' }>
        {modalContent.image.length > 0 && <img className='modal-feature-img' src={modalContent.image[0].url} alt='Menu Insights Podcast' />}
        <div className={ 'content-box-wrapper medium centered' }>
          <div className={'modal-custom-btn-panel centered mt-3'}>
            <div className={ isCanadianUser || verificationStatus === GBP_VERIFICATION_STATUS.SUCCESS || gbpSuccessAlert ? null : 'flex justify-center'}>
              <div className={ isCanadianUser ? null :'px-25 separator-right'}>
                {verificationStatus === GBP_VERIFICATION_STATUS.SUCCESS || gbpSuccessAlert ?
                  null : <p className={'modal-text-description'}>
                    {modalContent.left_section_description}
                  </p>}
                {isCanadianUser ?
                  <Button className='mui-btn--success mt-20' onClick={() => onVisitGbpProfile()}>
                    {modalContent.right_section_button.title}
                  </Button> : null
                }
                {verificationStatus === GBP_VERIFICATION_STATUS.SUCCESS || gbpSuccessAlert ?
                  null :
                  <Button className='mui-btn mui-btn--secondary mt-20' type='button' onClick={() => this.onGmbConsultationSceduleClick(user)}>
                    {modalContent.left_section_button.title}
                  </Button>}
              </div>
              <div className={'px-25'}>
                <p className={'modal-text-description'}>
                  {isCanadianUser ? null : gbpSuccessAlert ? successAlertMessage : modalContent.right_section_description}
                </p>
                {isCanadianUser ? null : [GBP_VERIFICATION_STATUS.IN_PROGRESS, GBP_VERIFICATION_STATUS.VERIFIED].includes(verificationStatus) ?
                  <Button className='mui-btn--success mt-20' onClick={() => onVisitGbpProfile()}>
                    {modalContent.right_section_button.title}
                  </Button> :
                  <a
                    key='gbp-login'
                    className='mui-btn mui-btn--success mt-20'
                    href={GbpOverviewModal.getGoogleLoginUrl(false)}
                  >
                    {modalContent.right_section_button.title}
                  </a>}
              </div>
            </div>
          </div>
        </div>
      </div>);
  });

  render() {
    const {
      isOpen,
      user,
    } = this.props;

    return (
      <Modal
        disableScroll
        open={ isOpen }
        width={ 'common-small-overlay-body' }
        headerComponent={ <GbpModalHeader onToggleModal={ this.closeGmbModal } /> }
        contentComponent={ this.renderBody(user) }
      />
    );
  }
}

export default GbpOverviewModal;
